import CustomList from '../../../../core/components/core/Util/List/CustomList/CustomList';
import CustomListContainer from '../../../../core/components/core/Util/List/CustomList/CustomListContainer';
import config from '../../../config/config';
import { useParams } from "react-router-dom";
import { useNavigate } from 'react-router-dom';

function List() {
  const navigate = useNavigate();

  const { id } = useParams();

  const pathFrontEnd = '/employeepayments/';
  const paths = {
    pathAdd: pathFrontEnd + 'add',
    pathEdit: pathFrontEnd + 'edit',
    pathView: pathFrontEnd + 'view',
    endpointDelete: `${config.endpoints.backend}employeepayments/delete`,
    endpoint: config.endpoints.backend + 'employeepayments/getall'
  }

  let list = {
    labelTitle: 'Lista de Pagamentos',
    labelTitleButtonAdd: 'Importar pagamentos',
    buttonsListContainer: [
      {
        name: 'go_back_list',
        class: 'btn btn-secondary',
        label: 'Voltar',
        tooltipLabel: 'Voltar para listagem de competências',
        callback: async () => {
          navigate(`/fileemployeepayments/list`)
        }
      }
    ],
    fieldsShowOnDelete: ['competency_date'],
    showPrintButtons: true,
    canAdd: false,
    canEdit: false,
    canView: false,
    canDelete: false,
    viewActionColumn: false,
    filter: {
      pdc_file_id: id
    },
    columns: [
      {
        name: 'employeeid',
        label: 'ID Empregado',
      },
      {
        name: 'employee_name',
        label: 'Empregado',
        width: "25%"
      },
      {
        name: 'salary',
        label: 'Salário',
      },
      {
        name: 'other_prov',
        label: 'Out.Prov.',
      },
      {
        name: 'fam_salary',
        label: 'Sal.Fam.',
      },
      {
        name: 'inss',
        label: 'INSS',
      },
      {
        name: 'irrf',
        label: 'IRRF',
      },
      {
        name: 'other_desc',
        label: 'Out.Desc.',
      },
      {
        name: 'liquid_salary',
        label: 'Líquido',
      },
      {
        name: 'fgts',
        label: 'FGTS',
      }
    ]
  };

  list = { ...list, ...paths };

  return (
    <div>
      <CustomListContainer
        buttons={list.buttonsListContainer}
        pathAdd={list.pathAdd}
        labelTitle={list.labelTitle}
        labelTitleButtonAdd={list.labelTitleButtonAdd}
        canAdd={list.canAdd}
        content={<CustomList list={{ ...list, ...paths }} />}
      />
    </div>
  );
}
export default List;
